import Promocv from "./promo-cherryville.webp";
import Promogl from "./promo-gardenloft.webp";
import Promowt from "./promo-waterterrace.webp";
import Promotm from "./promo-tanamas.webp";
import Promozl from "./promo-zliving.webp";
import Promotk from "./promo-thekaia.webp";
import Promolv from "./promo-levante.webp";
import Promovc from "./promo-vicente.webp";
import Promogm from "./promo-grandlemonade.webp";
import Promoo8 from "./promo-o8.webp";
import Promogv from "./promo-giva.png";
import Promoah from "./promo-altara.png";

const promodetail = {
  Promocv,
  Promogl,
  Promowt,
  Promotm,
  Promozl,
  Promotk,
  Promolv,
  Promovc,
  Promogm,
  Promoo8,
  Promogv,
  Promoah,
};

export default promodetail;
